import { render, staticRenderFns } from "./SelectableCard.vue?vue&type=template&id=0a57785e&scoped=true"
import script from "./SelectableCard.vue?vue&type=script&lang=js"
export * from "./SelectableCard.vue?vue&type=script&lang=js"
import style0 from "./SelectableCard.vue?vue&type=style&index=0&id=0a57785e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a57785e",
  null
  
)

export default component.exports